import { formatArea, formatCondition, formatAdjustedArea, formatPercentage } from 'src/utils/formatters';


export const groupByFormation = (data, year1, year2, areaType) => {
  const totalRow = data.find(item => item.isTotal);
  const dataWithoutTotal = data.filter(item => !item.isTotal);

  const grouped = dataWithoutTotal.reduce((acc, item) => {
    const formation = item.formation;
    if (!acc[formation]) {
      acc[formation] = {
        ecosystem: formation,
        formation: formation,
        vegetationFloor: '-',
        landUse: '-',
        [`area${year1}`]: 0,
        [`condition${year1}`]: 0,
        [`adjustedArea${year1}`]: 0,
        [`area${year2}`]: 0,
        [`condition${year2}`]: 0,
        [`adjustedArea${year2}`]: 0,
        areaVariation: 0,
        conditionVariation: 0,
        adjustedAreaVariation: 0,
        primaryAreaVariation: 0,
        percentageVariation: 0,
        performance: 'Sin cambio',
        count: 0,
      };
    }

    acc[formation][`area${year1}`] += item[`area${year1}`];
    acc[formation][`area${year2}`] += item[`area${year2}`];
    acc[formation][`adjustedArea${year1}`] += item[`adjustedArea${year1}`];
    acc[formation][`adjustedArea${year2}`] += item[`adjustedArea${year2}`];
    acc[formation].areaVariation += item.areaVariation;
    acc[formation].adjustedAreaVariation += item.adjustedAreaVariation;
    acc[formation].primaryAreaVariation += item.primaryAreaVariation || 0;
    acc[formation].count += 1;

    return acc;
  }, {});

  const groupedArray = Object.values(grouped).map(group => {
    const avgCondition1 = group[`adjustedArea${year1}`] / group[`area${year1}`] || 0;
    const avgCondition2 = group[`adjustedArea${year2}`] / group[`area${year2}`] || 0;
    const conditionVariation = avgCondition2 - avgCondition1;

    const primaryArea1 = areaType === 'area' ? group[`area${year1}`] : group[`adjustedArea${year1}`];
    const primaryArea2 = areaType === 'area' ? group[`area${year2}`] : group[`adjustedArea${year2}`];
    const primaryVariation = areaType === 'area' ? group.areaVariation : group.adjustedAreaVariation;

    const percentageVariation = primaryArea1 !== 0
      ? ((primaryArea2 - primaryArea1) / primaryArea1) * 100
      : 0;

    let performance = 'Sin pérdidas';
    if (primaryVariation > 0) {
      performance = 'Ganancia';
    } else if (primaryVariation < 0) {
      performance = 'Pérdida';
    }

    return {
      ...group,
      [`condition${year1}`]: avgCondition1,
      [`condition${year2}`]: avgCondition2,
      conditionVariation,
      percentageVariation,
      performance,
      areaType,
    };
  });

  if (totalRow) {
    groupedArray.push(totalRow);
  }

  return groupedArray;
};

export const groupByVegetationFloor = (data, year1, year2, areaType) => {
  const totalRow = data.find(item => item.isTotal);
  const dataWithoutTotal = data.filter(item => !item.isTotal);

  const grouped = dataWithoutTotal.reduce((acc, item) => {
    const vegetationFloor = item.vegetationFloor;
    if (!acc[vegetationFloor]) {
      acc[vegetationFloor] = {
        ecosystem: vegetationFloor,
        formation: '-',
        vegetationFloor: vegetationFloor,
        landUse: '-',
        [`area${year1}`]: 0,
        [`condition${year1}`]: 0,
        [`adjustedArea${year1}`]: 0,
        [`area${year2}`]: 0,
        [`condition${year2}`]: 0,
        [`adjustedArea${year2}`]: 0,
        areaVariation: 0,
        conditionVariation: 0,
        adjustedAreaVariation: 0,
        percentageVariation: 0,
        performance: 'Sin cambio',
        count: 0,
      };
    }

    acc[vegetationFloor][`area${year1}`] += item[`area${year1}`];
    acc[vegetationFloor][`area${year2}`] += item[`area${year2}`];
    acc[vegetationFloor][`adjustedArea${year1}`] += item[`adjustedArea${year1}`];
    acc[vegetationFloor][`adjustedArea${year2}`] += item[`adjustedArea${year2}`];
    acc[vegetationFloor].areaVariation += item.areaVariation;
    acc[vegetationFloor].adjustedAreaVariation += item.adjustedAreaVariation;
    acc[vegetationFloor].count += 1;

    return acc;
  }, {});

  const groupedArray = Object.values(grouped).map(group => {
    const avgCondition1 = group[`adjustedArea${year1}`] / group[`area${year1}`] || 0;
    const avgCondition2 = group[`adjustedArea${year2}`] / group[`area${year2}`] || 0;
    const conditionVariation = avgCondition2 - avgCondition1;

    const primaryArea1 = areaType === 'area' ? group[`area${year1}`] : group[`adjustedArea${year1}`];
    const primaryArea2 = areaType === 'area' ? group[`area${year2}`] : group[`adjustedArea${year2}`];
    const primaryVariation = areaType === 'area' ? group.areaVariation : group.adjustedAreaVariation;

    const percentageVariation = primaryArea1 !== 0
      ? ((primaryArea2 - primaryArea1) / primaryArea1) * 100
      : 0;

    let performance = 'Sin pérdidas';
    if (primaryVariation > 0) {
      performance = 'Ganancia';
    } else if (primaryVariation < 0) {
      performance = 'Pérdida';
    }

    return {
      ...group,
      [`condition${year1}`]: avgCondition1,
      [`condition${year2}`]: avgCondition2,
      conditionVariation,
      percentageVariation,
      performance,
    };
  });

  if (totalRow) {
    groupedArray.push(totalRow);
  }

  return groupedArray;
};

export const groupByLandUse = (data, year1, year2, areaType) => {
  const totalRow = data.find(item => item.isTotal);
  const dataWithoutTotal = data.filter(item => !item.isTotal);

  const grouped = dataWithoutTotal.reduce((acc, item) => {
    const landUse = item.landUse;
    if (!acc[landUse]) {
      acc[landUse] = {
        ecosystem: landUse,
        formation: '-',
        vegetationFloor: '-',
        landUse: landUse,
        [`area${year1}`]: 0,
        [`condition${year1}`]: 0,
        [`adjustedArea${year1}`]: 0,
        [`area${year2}`]: 0,
        [`condition${year2}`]: 0,
        [`adjustedArea${year2}`]: 0,
        areaVariation: 0,
        conditionVariation: 0,
        adjustedAreaVariation: 0,
        percentageVariation: 0,
        performance: 'Sin cambio',
        count: 0,
      };
    }

    acc[landUse][`area${year1}`] += item[`area${year1}`];
    acc[landUse][`area${year2}`] += item[`area${year2}`];
    acc[landUse][`adjustedArea${year1}`] += item[`adjustedArea${year1}`];
    acc[landUse][`adjustedArea${year2}`] += item[`adjustedArea${year2}`];
    acc[landUse].areaVariation += item.areaVariation;
    acc[landUse].adjustedAreaVariation += item.adjustedAreaVariation;
    acc[landUse].count += 1;

    return acc;
  }, {});

  const groupedArray = Object.values(grouped).map(group => {
    const avgCondition1 = group[`adjustedArea${year1}`] / group[`area${year1}`] || 0;
    const avgCondition2 = group[`adjustedArea${year2}`] / group[`area${year2}`] || 0;
    const conditionVariation = avgCondition2 - avgCondition1;

    const primaryArea1 = areaType === 'area' ? group[`area${year1}`] : group[`adjustedArea${year1}`];
    const primaryArea2 = areaType === 'area' ? group[`area${year2}`] : group[`adjustedArea${year2}`];
    const primaryVariation = areaType === 'area' ? group.areaVariation : group.adjustedAreaVariation;

    const percentageVariation = primaryArea1 !== 0
      ? ((primaryArea2 - primaryArea1) / primaryArea1) * 100
      : 0;

    let performance = 'Sin pérdidas';
    if (primaryVariation > 0) {
      performance = 'Ganancia';
    } else if (primaryVariation < 0) {
      performance = 'Pérdida';
    }

    return {
      ...group,
      [`condition${year1}`]: avgCondition1,
      [`condition${year2}`]: avgCondition2,
      conditionVariation,
      percentageVariation,
      performance,
    };
  });

  if (totalRow) {
    groupedArray.push(totalRow);
  }

  return groupedArray;
};

// Función para aplicar agrupación según el viewMode
export const applyTableGrouping = (data, viewMode, year1, year2, areaType) => {
  if (viewMode === 'formation') {
    return groupByFormation(data, year1, year2, areaType);
  } else if (viewMode === 'vegetation-floor') {
    return groupByVegetationFloor(data, year1, year2, areaType);
  } else if (viewMode === 'land-use') {
    return groupByLandUse(data, year1, year2, areaType);
  }
  return data; // Para viewMode === 'total'
};

// Funciones utilitarias para CSV
export const convertToCSV = (data, headers) => {
  const csvHeaders = headers.join(',');
  const csvRows = data.map(row =>
    row.map(field => {
      // Escapar comillas y wrap en comillas si contiene comas
      const stringField = String(field || '');
      if (stringField.includes(',') || stringField.includes('"') || stringField.includes('\n')) {
        return `"${stringField.replace(/"/g, '""')}"`;
      }
      return stringField;
    }).join(','),
  );

  return [ csvHeaders, ...csvRows ].join('\n');
};

export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([ csvContent ], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');

  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Función principal para generar y descargar CSV de tabla de ecosistemas
export const generateEcosystemTableCSV = (data, comparisonYears, viewMode, areaType) => {
  try {
    // Obtener los datos de la tabla (datos raw)
    const rawEcosystemData = getTableData(data, comparisonYears[0], comparisonYears[1], areaType);

    // Aplicar agrupación
    const tableData = applyTableGrouping(rawEcosystemData, viewMode, comparisonYears[0], comparisonYears[1], areaType);

    // Definir headers según el modo de vista y tipo de área
    const [ year1, year2 ] = comparisonYears;
    const baseHeaders = [];

    if (viewMode === 'vegetation-floor') {
      baseHeaders.push('Piso vegetacional');
    } else if (viewMode === 'land-use') {
      baseHeaders.push('Uso de suelo');
    } else {
      baseHeaders.push('Formación');
      if (viewMode === 'total') {
        baseHeaders.push('Piso vegetacional', 'Uso de suelo');
      }
    }

    baseHeaders.push(`Área [Ha] ${year1}`);

    if (areaType === 'adjustedArea') {
      baseHeaders.push(`Condición ${year1}`, `Área ajustada [Ha] ${year1}`);
    }

    baseHeaders.push(`Área [Ha] ${year2}`);

    if (areaType === 'adjustedArea') {
      baseHeaders.push(`Condición ${year2}`, `Área ajustada [Ha] ${year2}`);
    }

    const variationLabel = areaType === 'area' ? 'Variación Área [Ha] (%)' : 'Variación Área ajustada [Ha] (%)';
    baseHeaders.push(variationLabel, 'Desempeño');

    // Convertir datos a formato CSV
    const csvData = tableData.map(item => {
      const row = [];

      // Columna principal según viewMode
      if (viewMode === 'vegetation-floor') {
        row.push(item.vegetationFloor);
      } else if (viewMode === 'land-use') {
        row.push(item.landUse);
      } else {
        row.push(item.isTotal ? 'TOTAL' : item.formation);
        if (viewMode === 'total') {
          row.push(item.vegetationFloor, item.landUse);
        }
      }

      // Datos de área año 1
      row.push(formatArea(item[`area${year1}`]));

      if (areaType === 'adjustedArea') {
        row.push(formatCondition(item[`condition${year1}`]));
        row.push(formatAdjustedArea(item[`adjustedArea${year1}`]));
      }

      // Datos de área año 2
      row.push(formatArea(item[`area${year2}`]));

      if (areaType === 'adjustedArea') {
        row.push(formatCondition(item[`condition${year2}`]));
        row.push(formatAdjustedArea(item[`adjustedArea${year2}`]));
      }

      // Variación y desempeño
      const variation = areaType === 'area' ? item.areaVariation : item.adjustedAreaVariation;
      const percentage = item.percentageVariation;
      const variationSign = variation >= 0 ? '+' : '';
      const percentageSign = percentage >= 0 ? '+' : '';
      const formattedVariation = `${variationSign}${formatAdjustedArea(variation)} (${percentageSign}${formatPercentage(percentage)}%)`;

      const performance = percentage > 0 ? 'Ganancia' : percentage < 0 ? 'Pérdida' : 'Sin cambio';

      row.push(formattedVariation, performance);

      return row;
    });

    // Generar nombre de archivo
    const viewModeLabel = viewMode === 'total' ? 'completo'
      : viewMode === 'formation' ? 'formacion'
      : viewMode === 'vegetation-floor' ? 'piso-vegetacional'
      : 'uso-suelo';

    const areaTypeLabel = areaType === 'area' ? 'area' : 'area-ajustada';
    const filename = `inventario-ecosistemas-${viewModeLabel}-${areaTypeLabel}-${year1}-${year2}.csv`;

    // Convertir a CSV y descargar
    const csvContent = convertToCSV(csvData, baseHeaders);
    downloadCSV(csvContent, filename);

    return true;
  } catch (error) {
    console.error('Error al generar CSV:', error);
    return false;
  }
};

export const getTableData = (data, year1 = 2020, year2 = 2024, areaType = 'adjustedArea') => {
  const ecosystemRows = data.ecosystems.map(ecosystem => {
    const data1 = ecosystem.data[year1];
    const data2 = ecosystem.data[year2];

    const area1 = data1.area;
    const condition1 = data1.condition;
    const adjustedArea1 = area1 * condition1;

    const area2 = data2.area;
    const condition2 = data2.condition;
    const adjustedArea2 = area2 * condition2;

    const areaVariation = area2 - area1;
    const conditionVariation = condition2 - condition1;
    const adjustedAreaVariation = adjustedArea2 - adjustedArea1;

    // Determinar variación primaria según el tipo de área seleccionado
    const primaryAreaVariation = areaType === 'area' ? areaVariation : adjustedAreaVariation;
    const primaryArea1 = areaType === 'area' ? area1 : adjustedArea1;

    // Calcular porcentaje de variación
    const percentageVariation = primaryArea1 !== 0 ?
      ((primaryAreaVariation) / primaryArea1) * 100 : 0;

    // Determinar performance
    let performance = 'Sin pérdidas';
    if (primaryAreaVariation > 0) {
      performance = 'Ganancia';
    } else if (primaryAreaVariation < 0) {
      performance = 'Pérdida';
    }

    return {
      id: ecosystem.id,
      ecosystem: ecosystem.name,
      formation: ecosystem.formation,
      vegetationFloor: ecosystem.vegetationFloor,
      conservationStatus: ecosystem.conservationStatus,
      landUse: ecosystem.landUse,
      [`area${year1}`]: area1,
      [`condition${year1}`]: condition1,
      [`adjustedArea${year1}`]: adjustedArea1,
      [`area${year2}`]: area2,
      [`condition${year2}`]: condition2,
      [`adjustedArea${year2}`]: adjustedArea2,
      areaVariation,
      conditionVariation,
      adjustedAreaVariation,
      primaryAreaVariation,
      percentageVariation,
      performance,
      areaType,
    };
  });

  // Calcular totales según el tipo de área
  const totalArea1 = ecosystemRows.reduce((sum, row) => sum + row[`area${year1}`], 0);
  const totalArea2 = ecosystemRows.reduce((sum, row) => sum + row[`area${year2}`], 0);
  const totalAdjustedArea1 = ecosystemRows.reduce((sum, row) => sum + row[`adjustedArea${year1}`], 0);
  const totalAdjustedArea2 = ecosystemRows.reduce((sum, row) => sum + row[`adjustedArea${year2}`], 0);

  const totalPrimaryArea1 = areaType === 'area' ? totalArea1 : totalAdjustedArea1;
  const totalPrimaryArea2 = areaType === 'area' ? totalArea2 : totalAdjustedArea2;
  const totalPrimaryAreaVariation = totalPrimaryArea2 - totalPrimaryArea1;
  const totalPercentageVariation = totalPrimaryArea1 !== 0 ?
    ((totalPrimaryArea2 - totalPrimaryArea1) / totalPrimaryArea1) * 100 : 0;

  let totalPerformance = 'Sin pérdidas';
  if (totalPrimaryAreaVariation > 0) {
    totalPerformance = 'Ganancia';
  } else if (totalPrimaryAreaVariation < 0) {
    totalPerformance = 'Pérdida';
  }

  // Agregar fila de totales
  const totalRow = {
    id: 'total',
    ecosystem: 'TOTAL',
    formation: '-',
    vegetationFloor: '-',
    conservationStatus: '-',
    landUse: '-',
    [`area${year1}`]: totalArea1,
    [`condition${year1}`]: areaType === 'area' ? '-' : '-',
    [`adjustedArea${year1}`]: totalAdjustedArea1,
    [`area${year2}`]: totalArea2,
    [`condition${year2}`]: areaType === 'area' ? '-' : '-',
    [`adjustedArea${year2}`]: totalAdjustedArea2,
    areaVariation: totalArea2 - totalArea1,
    conditionVariation: '-',
    adjustedAreaVariation: totalAdjustedArea2 - totalAdjustedArea1,
    primaryAreaVariation: totalPrimaryAreaVariation,
    percentageVariation: totalPercentageVariation,
    performance: totalPerformance,
    areaType,
    isTotal: true,
  };

  return [ ...ecosystemRows, totalRow ];
};

export const getChartData = (data, metric = 'area', viewMode = 'total') => {
  const years = data.availableYears;

  // Si es modo total, usar la lógica original
  if (viewMode === 'total') {
    return getOriginalChartData(data, metric, years);
  }

  // Para modos agrupados, generar datos agrupados
  return getGroupedChartData(data, metric, viewMode, years);
};

const getOriginalChartData = (data, metric, years) => {
  // Colores para cada ecosistema (expandida para 37 ecosistemas)
  const colors = [
    '#2E7D32', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722',
    '#8D6E63', '#795548', '#607D8B', '#546E7A', '#455A64', '#37474F', '#263238', '#1B1B1B',
    '#0277BD', '#0288D1', '#0097A7', '#00695C', '#2E7D32', '#388E3C', '#4FC3F7', '#26C6DA',
    '#B39DDB', '#9C27B0', '#E91E63', '#F44336', '#9E9E9E', '#607D8B', '#795548', '#8D6E63',
    '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107',
  ];

  // Datasets para cada ecosistema
  const ecosystemDatasets = data.ecosystems.map((ecosystem, index) => ({
    label: ecosystem.name,
    data: years.map(year => {
      const yearData = ecosystem.data[year];
      if (metric === 'area') {
        return yearData.area;
      } else if (metric === 'condition') {
        return yearData.condition;
      } else if (metric === 'adjustedArea') {
        return yearData.area * yearData.condition;
      }
      return yearData[metric];
    }),
    borderColor: colors[index % colors.length],
    backgroundColor: `${colors[index % colors.length]}20`,
    borderWidth: 2,
    fill: false,
    tension: 0.1,
  }));

  // Agregar línea de total para área y área ajustada
  if (metric === 'area' || metric === 'adjustedArea') {
    const totalData = years.map(year => {
      if (metric === 'area') {
        return data.ecosystems.reduce((sum, ecosystem) =>
          sum + ecosystem.data[year].area, 0);
      } else if (metric === 'adjustedArea') {
        return data.ecosystems.reduce((sum, ecosystem) => {
          const yearData = ecosystem.data[year];
          return sum + (yearData.area * yearData.condition);
        }, 0);
      }
      return 0;
    });

    let totalLabel = 'Total Área';
    if (metric === 'adjustedArea') {
      totalLabel = 'Total Área Ajustada';
    }

    ecosystemDatasets.push({
      label: totalLabel,
      data: totalData,
      borderColor: colors[colors.length - 1],
      backgroundColor: `${colors[colors.length - 1]}20`,
      borderWidth: 2,
      borderDash: [ 5, 5 ],
      fill: false,
      tension: 0.1,
    });
  }

  return {
    labels: years,
    datasets: ecosystemDatasets,
  };
};

const getGroupedChartData = (data, metric, viewMode, years) => {
  // Colores para grupos
  const colors = [
    '#2E7D32', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722',
    '#8D6E63', '#795548', '#607D8B', '#546E7A', '#455A64', '#37474F', '#263238', '#1B1B1B',
  ];

  // Determinar el campo de agrupación
  let groupField;
  switch (viewMode) {
    case 'formation':
      groupField = 'formation';
      break;
    case 'vegetation-floor':
      groupField = 'vegetationFloor';
      break;
    case 'land-use':
      groupField = 'landUse';
      break;
    default:
      groupField = 'formation';
  }

  // Agrupar ecosistemas por el campo seleccionado
  const grouped = data.ecosystems.reduce((acc, ecosystem) => {
    const groupKey = ecosystem[groupField];
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
    acc[groupKey].push(ecosystem);
    return acc;
  }, {});

  // Crear datasets para cada grupo
  const groupDatasets = Object.keys(grouped).map((groupName, index) => {
    const groupEcosystems = grouped[groupName];

    // Calcular valores agregados por año para este grupo
    const groupData = years.map(year =>
      groupEcosystems.reduce((sum, ecosystem) => {
        const yearData = ecosystem.data[year];
        if (metric === 'area') {
          return sum + yearData.area;
        } else if (metric === 'condition') {
          // Para condición, calcular promedio ponderado por área
          const totalArea = groupEcosystems.reduce((areaSum, eco) => areaSum + eco.data[year].area, 0);
          return sum + (yearData.area * yearData.condition) / totalArea;
        } else if (metric === 'adjustedArea') {
          return sum + (yearData.area * yearData.condition);
        }
        return sum + yearData[metric];
      }, 0),
    );

    return {
      label: groupName,
      data: groupData,
      borderColor: colors[index % colors.length],
      backgroundColor: `${colors[index % colors.length]}20`,
      borderWidth: 2,
      fill: false,
      tension: 0.1,
    };
  });

  // Agregar línea de total si es área o área ajustada
  if (metric === 'area' || metric === 'adjustedArea') {
    const totalData = years.map(year => {
      if (metric === 'area') {
        return data.ecosystems.reduce((sum, ecosystem) =>
          sum + ecosystem.data[year].area, 0);
      } else if (metric === 'adjustedArea') {
        return data.ecosystems.reduce((sum, ecosystem) => {
          const yearData = ecosystem.data[year];
          return sum + (yearData.area * yearData.condition);
        }, 0);
      }
      return 0;
    });

    let totalLabel = 'Total Área';
    if (metric === 'adjustedArea') {
      totalLabel = 'Total Área Ajustada';
    }

    groupDatasets.push({
      label: totalLabel,
      data: totalData,
      borderColor: '#000000',
      backgroundColor: '#00000020',
      borderWidth: 2,
      borderDash: [ 5, 5 ],
      fill: false,
      tension: 0.1,
    });
  }

  return {
    labels: years,
    datasets: groupDatasets,
  };
};
